module.exports = __webpack_public_path__ + "static/media/bitcoin.ab09bc27.png";